const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

const PriceDisplay = require('components/shared/price_display.jsx');
const listingWithAdditionalParams = require('./listing_with_aid.js').listingWithAdditionalParams;
const { MobileDetection } = require('@reverbdotcom/discovery-ui');

const SOFTWARE_CATEGORY_UUID = 'e71b6e43-7217-4746-b4e3-64bf708a2664';

class Upsell extends React.Component {
  getMainImage() {
    const links = this.props.upsell.photos[0]._links;

    if (MobileDetection.isMobileBrowser()) {
      return links.mobile_small.href;
    }

    return links.medium_square.href;
  }

  upsellWithParams() {
    return listingWithAdditionalParams(this.props.upsell, {
      _aid: this.props.aid,
      suggested_listing: true,
    });
  }

  upsellHref() {
    const upsell = this.upsellWithParams();
    return upsell._links.web.href;
  }

  get isDigitalListing() {
    return this.props.upsell.category_uuids.includes(SOFTWARE_CATEGORY_UUID);
  }

  renderAddToCartButton(upsellWithParams) {
    if (!this.props.addToCartButton) { return null; }

    const button = React.createElement(
      this.props.addToCartButton,
      {
        productId: upsellWithParams.id,
        className: 'upsell__add-to-cart-button',
        aid: this.props.aid,
        suggestedListing: true,
      }
    );
    return button;
  }

  renderTopPick() {
    if (!this.props.showTopPick) { return null; }

    return (
      <div className="upsell__card__top-pick">
        <span className="upsell__card__top-pick__logo"></span>
        {I18n.t('productShowPage.topPick')}
      </div>
    );
  }

  renderSidebarUpsell(href, upsellWithParams) {
    const classes = classNames('upsell__card', {
      'upsell__card--software': this.isDigitalListing,
    });

    return (
      <li className={classes}>
        <div className="upsell__card__img">
          <a className="upsell__card__img__link" href={href}>
            <img alt={upsellWithParams.title} src={this.getMainImage()} />
          </a>
          {this.renderTopPick()}
        </div>
        <div className="upsell__card__description">
          <a href={href} className="upsell__card__link">
            <h4 className="upsell__card__description__title">
              {upsellWithParams.title}
            </h4>
            <div className="upsell__card__description__price">
              <PriceDisplay price={upsellWithParams.price} />
            </div>
          </a>
          <div className="upsell__card__add-to-cart-container">
            {this.renderAddToCartButton(upsellWithParams)}
          </div>
        </div>
      </li>
    );
  }

  renderUpsell(href, upsellWithParams) {
    const classes = classNames('product-card', {
      'product-card--software': this.isDigitalListing,
    });

    return (
      <li className="card-grid__item">
        <div className={classes}>
          <div className="product-card-img-container">
            <a href={href}>
              <img alt={upsellWithParams.title} src={this.getMainImage()} />
            </a>
          </div>
          {this.renderTopPick()}
          <a href={href}>
            <div className="product-card-description">
              <h4 className="product-card-body-sized">
                {upsellWithParams.title}
              </h4>
              <div className="price-footer">
                <div className="product-card__price">
                  <PriceDisplay price={upsellWithParams.price} />
                </div>
              </div>
              <div className="product-card__action">
                {this.renderAddToCartButton(upsellWithParams)}
              </div>
            </div>
          </a>
        </div>
      </li>
    );
  }

  render() {
    if (this.props.showSidebarUpsell) {
      return this.renderSidebarUpsell(this.upsellHref(), this.upsellWithParams());
    }

    return this.renderUpsell(this.upsellHref(), this.upsellWithParams());
  }
}

Upsell.propTypes = {
  upsell: PropTypes.object.isRequired,
  addToCartButton: PropTypes.func,
  aid: PropTypes.string,
  showSidebarUpsell: PropTypes.bool,
  showTopPick: PropTypes.bool,
};

Upsell.defaultProps = {
  aid: '',
};

module.exports = Upsell;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/upsell.jsx